import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//Servicios
import { PaymentsService } from 'src/app/services/payments.service';
import { AuthService } from '../../services/auth.service';
declare let gtag;

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  public orderId;
  public code;
  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private payments: PaymentsService,
    private router: Router) {
    this.authService.getProfile().subscribe(data => { }, erro => { });
    this.activatedRoute.queryParams.subscribe(params => {
      if (!params['paypal']) {
        if (localStorage.getItem('paymentData')) {

          var dataTransaction = JSON.parse(localStorage.getItem('paymentData'));
          localStorage.removeItem('paymentData');

          if (dataTransaction.code != undefined) {
            this.code = dataTransaction.order_id;
            this.sendGoogleTagOrderSuccess(this.code);
          } else {
            var json = {
              'membership_id': dataTransaction.membership_id,
              'pp': dataTransaction.pp,
              'email': dataTransaction.customer.email,
              'status': dataTransaction.status,
              'total': dataTransaction.total,
              'txn_id': dataTransaction.txn_id,
              'deviceIdHiddenFieldName': dataTransaction.user_id
            }
            this.payments.openpay3DSecure(dataTransaction).subscribe(request => {
              console.log("request_api_openpay", request);
              if (request['response'].status == true) {
                this.orderId = request['response'].data.payment_id;
                this.sendGoogleTagOrderSuccess(this.orderId);
              } else {
                this.router.navigateByUrl('/checkout/failure', request);
              }

            }, (err) => {
              this.router.navigateByUrl('/checkout/failure');
            });
          }

        } else {
          this.router.navigateByUrl('/checkout/home');
        }
      } else {
        this.orderId = 'XXX';
      }
    });

  }

  ngOnInit() {
  }


  private sendGoogleTagOrderSuccess(orderId){
    /* Event snippet for Website sale conversion page */
    gtag('event', 'conversion', { 'send_to': 'AW-934281867/KLTcCIKXn-oBEIuFwL0D', 'transaction_id': orderId }); 
  }

}
